import { render, staticRenderFns } from "./RequestFriendBox.vue?vue&type=template&id=f38f68d6&scoped=true"
import script from "./RequestFriendBox.vue?vue&type=script&lang=js"
export * from "./RequestFriendBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38f68d6",
  null
  
)

export default component.exports